import http from './api'

const url = '/new_features'

export const httpGetNewFeatures = () => {
  return http({
    url: `${url}/`,
    method: 'GET',
  })
}